import { useEffect, useState } from 'react';
import { getGiverdataSigned } from '../../../organization-actions';
import { useDispatch } from 'react-redux';
import GiverdataStatusMessage from '../giverdata-status-message/GiverdataStatusMessage';

export const ConsentRequiredWrapper = ({
    organization,
    notConsentedHeader,
    notConsentedBody,
    consentedHeader,
    consentedBody,
}) => {
    const [signed, setSigned] = useState(false);
    const storedGiverInfo = organization?.profile?.giverInfo;
    const signedAndStoredGiverInfoEmail = signed && storedGiverInfo?.organizationEmail;

    const dispatch = useDispatch();
    useEffect(() => {
        if (organization?.id) {
            dispatch(getGiverdataSigned({ organizationId: organization?.id })).then((data) => {
                setSigned(data.signed);
            });
        }
    }, [dispatch, organization?.id]);

    return (
        <>
            {signedAndStoredGiverInfoEmail ? consentedHeader : notConsentedHeader}
            <GiverdataStatusMessage
                organization={organization}
                signed={signed}
                organizationEmail={storedGiverInfo?.organizationEmail}
            />
            {signedAndStoredGiverInfoEmail ? consentedBody : notConsentedBody}
        </>
    );
};
